import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedPipesModule } from '../../../../shared/pipes/shared-pipes.module';
import { CommercialPermitService } from '../../../services/commercial-permit.service';
import { HistoricalCommercialVehiclePermitNumberModalComponent } from './historical-commercial-vehicle-permit-number-modal.component';
import { TableModule } from 'primeng/table';

@NgModule({
    declarations: [
        HistoricalCommercialVehiclePermitNumberModalComponent
    ],
    providers: [
        CommercialPermitService
    ],
    imports: [
        CommonModule,
        SharedPipesModule,
        TableModule,
    ],
    exports: [
        HistoricalCommercialVehiclePermitNumberModalComponent
    ]
})
export class HistoricalCommercialVehiclePermitModule {
}
